import { render, staticRenderFns } from "./SegmentManagement.vue?vue&type=template&id=730c052a&scoped=true&"
import script from "./SegmentManagement.vue?vue&type=script&lang=js&"
export * from "./SegmentManagement.vue?vue&type=script&lang=js&"
import style0 from "./SegmentManagement.vue?vue&type=style&index=0&id=730c052a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "730c052a",
  null
  
)

export default component.exports